var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F1F3FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4998,
    cy: 13.1693,
    r: 2.33333,
    stroke: "#214BA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 23.1693C10.8335 20.2238 13.5198 17.8359 16.8335 17.8359",
    stroke: "#214BA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1168 18.8359C19.4081 18.8359 18.8335 19.5055 18.8335 20.3314C18.8335 21.8269 20.3502 23.1864 21.1668 23.5026C21.9835 23.1864 23.5002 21.8269 23.5002 20.3314C23.5002 19.5055 22.9256 18.8359 22.2168 18.8359C21.7828 18.8359 21.3991 19.087 21.1668 19.4713C20.9346 19.087 20.5509 18.8359 20.1168 18.8359Z",
    stroke: "#214BA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval);
export default __webpack_public_path__ + "static/media/pending-approval.13184ed624bdb867b7504be7df3e68aa.svg";
export { ForwardRef as ReactComponent };